import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgElectricalVehicleChargingStationinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeLinejoin: "round",
		stroke: "currentColor",
		strokeWidth: 2,
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M55 18v27c0 1.975-.9 3-2.5 3-2.275 0-2.5-1.96-2.5-3V33c0-2.006-1-3.006-3-3h-7.5" }),
			/* @__PURE__ */ _jsx("path", {
				d: "M49 20c4.97 0 9-3.134 9-7s-4.03-7-9-7m-7 3h7m-7 8h7",
				strokeLinecap: "square"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M49 20V6",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M26 52H4V40.613C4 37.538 5.666 36 8.999 36H41c3.334 0 5 1.538 5 4.613V52H26z",
				strokeLinecap: "square"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 46a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm26 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4z",
				strokeLinecap: "square"
			}),
			/* @__PURE__ */ _jsx("path", { d: "M8 36c.642-1.407 1.642-3.74 3-7 2.037-4.89 2.5-6 7-6h14c4.5 0 4.963 1.11 7 6 1.358 3.26 2.358 5.593 3 7" }),
			/* @__PURE__ */ _jsx("path", {
				d: "M10 52v6m30-6v6",
				strokeLinecap: "square"
			})
		]
	})
});
export default SvgElectricalVehicleChargingStationinline;
